"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _get2 = _interopRequireDefault(require("lodash/get"));

var _authActionKeys = _interopRequireDefault(require("../auth/authActionKeys"));

var _immutable = require("immutable");

var _identify = _interopRequireDefault(require("../analytics/identify"));

var _createReducer2 = _interopRequireDefault(require("../createReducer"));

var _analyticsActionKeys = require("./analyticsActionKeys");

var _tracker = _interopRequireDefault(require("./tracker"));

var InitialState = new _immutable.Record({
  identify: {
    userId: null,
    tracked: false
  }
});

var _default = (0, _createReducer2.default)(new InitialState(), (0, _defineProperty2.default)({}, _authActionKeys.default.LOGIN_SUCCESS, function (state, action) {
  var user = (0, _get2.default)(action, 'payload.body.user') || {};

  if (!state.get('identify.tracked')) {
    return (0, _identify.default)({
      userId: user.id,
      firstName: user.firstName,
      lastName: user.lastName,
      email: user.email
    }) ? state.merge({
      identify: {
        userId: user.id,
        tracked: true
      }
    }) : state;
  }

  return state;
}));

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-app-platform/lib/common/analytics/analyticsReducer.js
// module id = 4427
// module chunks = 25